//
//
//
//
//

export default {
    props: ['products'],
};
